
import './App.css';
import Dashboard from './components/Dashboard';
import { useLocation } from 'react-router-dom';

import AccountForm from './components/AccountForm';
import Sidebar from './components/Sidebar';
import { BrowserRouter, Routes, Route, } from 'react-router-dom';
import LogIn from './components/LogIn';
import State from './components/Master/State/State';
import Employee from './components/Master/Employee/Employee';
import AddEmployee from './components/Master/Employee/AddEmployee';
import EditEmployee from './components/Master/Employee/EditEmployee';
import Designation from './components/Master/Designation/Designation';
import Department from './components/Master/Department/Department';
import Concession from './components/Master/Concession/Concession';
import City from './components/Master/City/City';
import ChargeDetails from './components/Master/ChargeDetails/ChargeDetails';
import Organization from './components/Master/Organisation/Organization';
import Country from './components/Master/country/Country';
import AddOrganisation from './components/Master/Organisation/AddOrganisation';
import EditOrganization from './components/Master/Organisation/EditOrganization';
import AddCountry from './components/Master/country/AddCountry';
import Purpose from './components/Master/Purpose/Purpose';

// import FeeGenerationForm from './components/fee/FeeGeneration';
import AdmissionForm from './components/AdmForm';
import AddRegistration from './components/Admission/Registration/AddRegistration';
import Registration from './components/Admission/Registration/Registration';


import StudentNotifications from './components/StudentLogin/StudentNotifications';
import TeacherNotifications from './components/Teacherlogin/TeacherNotifications';
import ParentNotifications from './components/Parents/pages/ParentNotifications';
import AdminNotifications from './components/Notifications/AdminNotifications';

import FeeGenerationForm from './components/Master/fee/FeeGeneration';
import AddState from './components/Master/State/AddState';
import Branch from './components/Master/Branch/Branch';
import ManageQuiz from './components/Master/Manage Quiz/ManageQuiz';

import UserGroup from './components/CPanel/UserGroup/UserGroup';
import EditCountry from './components/Master/country/EditCountry';
import LoadingBar from 'react-top-loading-bar';
import EditBranch from './components/Master/Branch/EditBranch';
import EditCity from './components/Master/City/EditCity';
import EditState from './components/Master/State/EditState';
import AddCity from './components/Master/City/AddCity';
import AddDesignation from './components/Master/Designation/AddDesignation';
import AddDepartment from './components/Master/Department/AddDepartment';
import EditDepartment from './components/Master/Department/EditDepartment';
import EditDesignation from './components/Master/Designation/EditDesignation';


import Protected from './components/Protected';

import Nationality from './components/Master/Nationality/Nationality';
import AddNationality from './components/Master/Nationality/AddNationality';
import EditNationality from './components/Master/Nationality/EditNationality';
import Source from './components/Master/Source/Source';
import CourseQuestion from './components/Master/CourseQuestion/CourseQuestion';
import InterestLevel from './components/Master/Interest Level/InterestLevel';
import DeliveryMode from './components/Master/Mode Of Delivery/DeliveryMode';

import AddInrstLvl from './components/Master/Interest Level/AddIntrstLvl';
import EditIntrstLvl from './components/Master/Interest Level/EditIntrstLvl';
import Form from './components/Master/AddForm/Form';
import AddForm from './components/Master/AddForm/AddForm';
import EditForm from './components/Master/AddForm/EditForm';

import AddSourceDetails from './components/Master/Source/AddSource';
import EditSourceDetails from './components/Master/Source/EditSource';
import AddDelivery from './components/Master/Mode Of Delivery/AddDeliveryMode';
import EditDelivery from './components/Master/Mode Of Delivery/EditDeliveryMode';
import Status from './components/Master/Status/Status';
import AddStatus from './components/Master/Status/AddStatus';
import EditStatus from './components/Master/Status/EditStatus';
import User from './components/CPanel/User/User';

import Course from './components/Course/Courses/Course';
import AddUserForm from './components/CPanel/User/AddUser';
import EditUserForm from './components/CPanel/User/EditUser';
import AddTopic from './components/Course/Topic/AddTopic';
import EditMasterTopic from './components/ClassMapping/Topic/EditMasterTopic';
import Module from './components/Course/Module/Module';
import AddCourse from './components/Course/Courses/AddCourse';
import EditModule from './components/Course/Module/EditModule';
import AddModule from './components/Course/Module/AddModule';
import Topic from './components/Course/Topic/Topic';



import AddUserGroup from './components/CPanel/UserGroup/AddUserGroup';
import EditUserGroup from './components/CPanel/UserGroup/EditUserGroup';
import AddUser from './components/CPanel/User/AddUser';
import EditUser from './components/CPanel/User/EditUser';
import EditCourse from './components/Course/Courses/EditCourse';
import AddBranch from './components/Master/Branch/AddBranch';
import Bank from './components/Master/Bank/Bank';
import ClassType from './components/Master/ClassType/ClassType';
import EditClassType from './components/Master/ClassType/EditClassType';
import AddClassType from './components/Master/ClassType/AddClassType';
import Religion from './components/Master/Religion/Religion';
import AddBank from './components/Master/Bank/AddBank';
import EditBank from './components/Master/Bank/EditBank';
import AddReligion from './components/Master/Religion/AddReligion';
import EditReligion from './components/Master/Religion/EditReligion';
import AddConcession from './components/Master/Concession/AddConcession';
import EditConcession from './components/Master/Concession/EditConcession';
import Occupation from './components/Master/Occupation/occupation';
import AddOccupation from './components/Master/Occupation/AddOccupation';
import EditOccupation from './components/Master/Occupation/EditOccupation';
import Section from './components/Master/Section/Section';
import SectionMaster from './components/Master/Section/Section';
import AddSection from './components/Master/Section/AddSection';
import ChargeMaster from './components/Master/Charge Master/ChargeMaster';
import AddCharge from './components/Master/Charge Master/AddChargeMaster';
import AddChargeMaster from './components/Master/Charge Master/AddChargeMaster';

import AddMasterTopic from './components/ClassMapping/Topic/AddMasterTopic';
import ClassMapping from './components/ClassMapping/ClassMapping';
import AddAdmission from './components/Admission/Admission/AddAdmission';
import Vehicle from './components/Master/Vehicle/Vehicle';
import AddVehicle from './components/Master/Vehicle/AddVehicle';
import DueDateDetails from './components/Master/Fine/Fine';
import AddFine from './components/Master/Fine/AddFine';
import Question from './components/Master/Question/Question';
import QuestionMaster from './components/Master/Question/AddQuestion';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import AddManageQuiz from './components/Master/Manage Quiz/AddManageQuiz';
import Admission from './components/Admission/Admission/Admission';
import UpdateAdmission from './components/Admission/Admission/UpdateAdmission';
import EditFine from './components/Master/Fine/EditFine';
import SubCategory from './components/Inventory/Sub Category/SubCategory';
import SubCategoryUpdate from './components/Inventory/Sub Category/EditSubCategory';
import Enquiry from './components/Enquiry/Enquiry';
import EnquiryDetails from './components/Enquiry/EnquiryDetails';
import EnquiryPage from './components/Enquiry/Enquiry';
import UpdateEnquiry from './components/Enquiry/UpdateEnquiry';
import EnquiryFollow from './components/Enquiry/EnquiryFollow';
import UpdateRegistration from './components/Admission/Registration/UpdateRegistration';
import Class from './components/Admission/class/Class';
import AddClass from './components/Admission/class/AddClass';
import SettingQuiz from './components/Master/Manage Quiz/AddManageQuiz';
import EditQuiz from './components/Master/Manage Quiz/EditQuiz';
import Assignment from './components/Assignment/Assignment';
import AssignementUpdate from './components/Assignment/AssignmentUpdate';
import FeeGeneration from './components/Master/fee/FeeGeneration';
import EditQuestion from './components/Master/Question/EditQuestion';
import SubjectMaster from './components/Master/SubjectMaster/AddsubjectMaster';
import FeeDeposit from './components/Master/fee/FeeDeposit';
import AnnualPayment from './components/Master/fee/AnnualPayment';
import EditSection from './components/Master/Section/EditSection';
import SubMaster from './components/Master/SubjectMaster/SubMaster';
import AddSubjectMaster from './components/Master/SubjectMaster/AddsubjectMaster';
import EditTopicMaster from './components/ClassMapping/Topic/EditMasterTopic';
import AddLession from './components/ClassMapping/Lession/AddLession';
import UpdateLession from './components/ClassMapping/Lession/UpdateLession';
import LessonPage from './components/ClassMapping/Lession/LessonPage';
import TopicPage from './components/ClassMapping/Topic/TopicPage';
import AddExamCriteria from './components/Examination/ExaminationCriteria/AddExamCriteria';
import AddExamSubCategory from './components/Examination/SubCategory/AddExamSubCategory';
import UpdateExamSubCategory from './components/Examination/SubCategory/UpdateExamSubCategory';
import AddExam from './components/Examination/Exam/AddExam';
import Result from './components/Result/Result';
import DemoReport from './components/Report/Payment';
import Payment from './components/Report/Payment';
import AdmissionReport from './components/Report/AdmReport/AdmissionReport';
import AttendanceReport from './components/Report/AttendanceReport';
import ClassPromotion from './components/Admission/Class Promotion/ClassPromotion';
import ReceiptPrint from './components/ReceiptPrint';
import Vendor from './components/Inventory/Vendor Master/vendor';
import AddVendor from './components/Inventory/Vendor Master/AddVendor';
import EditVendor from './components/Inventory/Vendor Master/EditVendor';
import Attendance from './components/Attendance/Attendance';
import Brand from './components/Inventory/Brand/Brand';
import AddAttendance from './components/Attendance/AddAttendance';
import AssignmentCreate from './components/Assignment/AssignmentCreate';
import ClassTeacherMapping from './components/ClassMapping/ClassTeacherMapping';
import EditVehicle from './components/Master/Vehicle/EditVehicle';
import ChangePassword from './components/ChangePassword';
import EditClass from './components/Admission/class/EditClass';
import UpdateSubMaster from './components/Master/SubjectMaster/UpdateSubMaster';
import ScanRegistration from './components/Admission/Registration/ScanRegistration';
import StudentsSidebar from './components/StudentLogin/StudentsSidebar';

import StdDashboard from './components/StudentLogin/StdDashboard';
import AssignmentDetails from './components/StudentLogin/AssignmentDetails';
import AssignmentCard from './components/StudentLogin/AssignmentCard';
import AssignmentList from './components/StudentLogin/AssignmentList';
import CommingSoon from './components/StudentLogin/CommingSoon';
import EditChargeMaster from './components/Master/Charge Master/EditChargeMaster';
import AdmissionManual from './components/Admission/Admission/AdmissionManual';
import FeeDuesDetails from './components/Master/fee/FeeDuesDetails';
import LeavingCertificate from "./components/SLC's/LeavingCertificate";
import SLCManagement from './components/SLC\'s/SLCManagement';
import GeneratePDFButton from "./components/SLC's/Certificate";
import CreateTimeTab from './components/TimeTable/CreateTimeTab';
import GetTimeTab from './components/TimeTable/GetTimeTab';
import TemplateTable from './components/Settings/Message Template/TemplateTable';
import TemplateForm from './components/Settings/Message Template/TemplateForm';
import ApiTable from './components/Settings/WhatsApp API/ApiTable';
import AddApiForm from './components/Settings/WhatsApp API/AddApiForm';
import ApiForm from './components/Settings/WhatsApp API/ApiForm';
import EditTemplate from './components/Settings/Message Template/EditTemplate';
import Caste from './components/Master/Caste/Caste';
import EditCaste from './components/Master/Caste/EditCaste';
import AddCaste from './components/Master/Caste/AddCaste';
import AttendanceForm from './components/Attendance/EmployeeAttendance/AttendanceForm';
import EmployeeAttendance from './components/Attendance/EmployeeAttendance/EmployeeAttendance';
import PeriodTable from './components/TimeTable/PeriodSequence/PeriodTable';
import AddPeriod from './components/TimeTable/PeriodSequence/AddPeriod';
import SubjectsPage from './components/StudentLogin/SubjectsPage';
import { LssnPg } from './components/StudentLogin/LssnPg';
import { TopicsPage } from './components/StudentLogin/TopicsPage';
import TymTbl from './components/StudentLogin/TymTbl';
import AssignmentCreateForm from './components/Assignment/AssignmentCreateForm';



import UpdateExamCriteria from './components/Examination/ExaminationCriteria/UpdateExamCriteria';
import ResultGeneration from './components/Result/ResultGeneration';
import GeneratedResult from './components/Result/GeneratedResult';
import StudentUser from './components/CPanel/StudentUsers/StudentUser';
import CreateNewUser from './components/CPanel/StudentUsers/CreateNewUser';
import StreamPage from './components/Master/Stream/StreamPage';
import AdmitPage from './components/Examination/AdmitCard/AdmitPage';
import AdmitCard from './components/Examination/AdmitCard/AdmitCard';

// parent module imports
import Header from './components/Parents/components/Header';
import ParentSidebar from './components/Parents/components/Sidebar';
import ParentDashboard from './components/Parents/components/Dashboard';
import ParentAttendance from './components/Parents/pages/Attendance';
import ParentsChatApp from './components/Parents/pages/ChatApp';
import ParentsAssignmentNotifications from './components/Parents/pages/Assignment';


import MainCategory from './components/Inventory/Main Category/MainCategory';
import AddMainCategory from './components/Inventory/Main Category/AddMainCategory';
import EditMainCategory from './components/Inventory/Main Category/EditMainCategory';
import ManageInventoryItems from './components/Inventory/Item Master/ManageInventoryItems';
import AddInventoryItem from './components/Inventory/Item Master/AddInventoryItem';
import EditInventoryItem from './components/Inventory/Item Master/EditInventoryItem';
import InventoryLocation from './components/Inventory/Location/InventoryLocation';
import AddLocation from './components/Inventory/Location/AddLocation';
import EditLocation from './components/Inventory/Location/EditLocation';

// Student Notification Added
import Notification from './components/StudentLogin/Notification'
import StudentTopicProgress from './components/StudentLogin/StudentTopicProgress';

// Teacher Module Imports 



// Stock Inward
import StockInward from './components/Inventory/Stock Inward/StockInward';
import AddStockInward from './components/Inventory/Stock Inward/AddStockInward';
import EditStockInward from './components/Inventory/Stock Inward/EditStockInward';
import StockIssuance from './components/Inventory/Stock Issuance/StockIssuance';

// Stock Return
import StockReturn from './components/Inventory/Stock Return/StockReturn';
import AddStockReturn from './components/Inventory/Stock Return/AddStockReturn';

// Transport
import ManageVehicle from './components/Transport/ManageVehicles/ManageVehicle'
import AddManageVehicle from './components/Transport/ManageVehicles/AddVehicle';
import EditManageVehicle from './components/Transport/ManageVehicles/EditVehicle'
import ManageRoute from './components/Transport/ManageRoutes/ManageRoute';
import AddRoutes from './components/Transport/ManageRoutes/AddRoutes';
import EditRoutes from './components/Transport/ManageRoutes/EditRoutes';
import Driver from './components/Transport/Driver/Driver';
import RouteVehicleMapping from './components/Transport/RouteVehicle/RouteVehicle';
import InventoryReport from './components/Inventory/Report/InventoryReport';
import ManageVehicleType from './components/Transport/VehicleTypeManage/ManageVehicleType';
import AddVehicleType from './components/Transport/VehicleTypeManage/AddVehicleType';
import EditVehicleType from './components/Transport/VehicleTypeManage/EditVehicleType';
import BulkIdCard from './components/Admission/Admission/BulkIdCard';
import AddPurpose from './components/Master/Purpose/AddPurpose';
import EditPurpose from './components/Master/Purpose/EditPurpose';
import AddStream from './components/Master/Stream/AddStream';
import EditStream from './components/Master/Stream/EditStream';
import EditPeriod from './components/TimeTable/PeriodSequence/EditPeriod';
import FormModules from './components/Admin Pages/Exclusive Permissions/Form Modules/FormModules';
import AddFormModules from './components/Admin Pages/Exclusive Permissions/Form Modules/AddFormModules';
import EditFormModules from './components/Admin Pages/Exclusive Permissions/Form Modules/EditFormModules';
import FormRegister from './components/Admin Pages/Exclusive Permissions/Form Register/FormRegister';
import AddFormRegister from './components/Admin Pages/Exclusive Permissions/Form Register/AddFormRegister';
import EditFormRegister from './components/Admin Pages/Exclusive Permissions/Form Register/EditFormRegister';
import ManageUser from './components/Admin Pages/Panel/Manage User/ManageUser';
import IdleTimeout from './components/IdleTimeout';
import TeacherSidebar from './components/Teacherlogin/TeacherSidebar';
import DashboardMain from './components/Teacherlogin/DashboardMain';
import DashContent from './components/Teacherlogin/DashContent';
import TimetablePage from './components/Teacherlogin/TimetablePage';
import AdmitCardPage from './components/Teacherlogin/AdmitCardPage';
import AdmitPagee from './components/Teacherlogin/AdmitPagee';
import ChatsApp from './components/Teacherlogin/ChatsApp';
import ViewAttendance from './components/Teacherlogin/ViewAttendance';
import AttendanceeForm from './components/Teacherlogin/AttendanceeForm';
import Lessons from './components/Teacherlogin/Lessons';
import LessonAdd from './components/Teacherlogin/LessonAdd';
import LessonEdit from './components/Teacherlogin/LessonEdit';
import Topics from './components/Teacherlogin/Topics';
import TopicAdd from './components/Teacherlogin/TopicAdd';
import TopicEdit from './components/Teacherlogin/TopicEdit';
import CreateAssignment from './components/Teacherlogin/CreateAssignment';
import ViewAssignment from './components/Teacherlogin/ViewAssignment';
import Exam from './components/Teacherlogin/Exam';
import EditAssignment from './components/Teacherlogin/EditAssignment';
import ProfileDetails from './components/Teacherlogin/ProfileDetails';
import SubjectDetail from './components/Teacherlogin/SubjectDetail';
import AllTopic from './components/Teacher Tracker/AllTopic';
import TopicProgress from './components/Teacher Tracker/TopicProgress';
import AddAllTopic from './components/Teacher Tracker/AddAllTopic';
import EditAllTopic from './components/Teacher Tracker/EditAllTopic';
import TopicProgresss from './components/Teacherlogin/TopicProgresss';
import TeacherAllTopics from './components/Teacherlogin/TeacherAllTopics';
import AddTeacherAllTopic from './components/Teacherlogin/AddTeacherAllTopic';
import EditTeacherAllTopic from './components/Teacherlogin/EditTeacherAllTopic';
import CreateAnnouncement from './components/AdminAnnouncement/CreateAnnouncement';
import ViewAnnouncement from './components/AdminAnnouncement/ViewAnnouncement';
import EditAnnouncement from "./components/AdminAnnouncement/EditAnnouncement";
import Announcement from './components/Teacherlogin/Announcement';
import TeacherAttendance from './components/Teacherlogin/TeacherAttendance';
import Homework from './components/Teacher Tracker/Homework';
import AddHomework from './components/Teacher Tracker/AddHomework';
import EditHomework from './components/Teacher Tracker/EditHomework';
import TeacherHomework from './components/Teacherlogin/TeacherHomework';
import ParentsPaymentPage from './components/Parents/pages/FeeReport';
import ParentsTimeTable from './components/Parents/pages/TimeTable';
import ParentTopicProgress from './components/Parents/pages/ParentsTopicTracker';
import ParentsHomwork from './components/Parents/pages/ParentsHomwork';
import ParentsAnnouncement from './components/Parents/pages/ParentsAnnouncement';
import ParentsResult from './components/Parents/pages/Result';
import StudentHomework from './components/StudentLogin/StudentHomework';
import AddTeacherHomework from './components/Teacherlogin/AddTeacherHomework';
import EditTeacherHomework from './components/Teacherlogin/EditTeacherHomework';
import StudentEnquiry from './components/Enquiry/StudentEnquiry';
import StudentRegistration from './components/Admission/Registration/StudentRegistration';
import Overview from './components/Teacher Load Tracker/Overview';
import TeacherLoadReport from './components/Teacher Load Tracker/TeacherLoadReport';
import TeacherLoadConfig from './components/Teacher Load Tracker/TeacherLoadConfig';
import TeacherLoadTimeTable from './components/Teacher Load Tracker/TeacherLoadTimeTable';
import SubjectTarget from './components/Teacher Load Tracker/SubjectTarget';
import TeacherLoadHeatmap from './components/Teacher Load Tracker/TeacherLoadHeatMap';
import ProxyManagement from './components/Teacher Load Tracker/ProxyManagement';
import MyDuties from './components/Teacherlogin/Myduties';
import TeacherTimeTablePage from './components/Teacherlogin/TeacherTimetablePage';

function App() {
  const theme = createTheme({
    typography: {
      fontFamily: [
        "Enriqueta",
        'serif'
      ].join(','),
    }
  });


  // .enriqueta-medium {
  //   font-family: "Enriqueta", serif;
  //   font-weight: 500;
  //   font-style: normal;
  // }
  return (
    <>
      <BrowserRouter>
        <IdleTimeout>
          <Routes>
            {/*  Parents Routes */}
            <Route path="/header" element={<Header />} />
            <Route path="/sidebar" element={<Sidebar />} />
           // Add these routes alongside your existing routes
            <Route path="/ParentDashboard" element={<ParentDashboard />} />
                   <Route
  path="/parent-notifications"
  element={<ParentDashboard content={<ParentNotifications />} />}
/>
            <Route path="/parents-view-result" element={<ParentDashboard content={<ParentsResult />} />} />
            <Route path="/parents-fee-report" element={<ParentDashboard content={<ParentsPaymentPage />} />} />
            <Route path="/parents-time-table" element={<ParentDashboard content={<ParentsTimeTable />} />} />
            <Route path="/parents-topic-tracker" element={<ParentDashboard content={<ParentTopicProgress />} />} />
            <Route path="/parents-homework" element={<ParentDashboard content={<ParentsHomwork />} />} />
            <Route path="/parents-announcement" element={<ParentDashboard content={<ParentsAnnouncement />} />} />
            <Route path="/parent-chat" element={<ParentDashboard content={<ParentsChatApp />} />} />
            <Route path="/parents-assignment" element={<ParentDashboard content={<ParentsAssignmentNotifications />} />} />
            <Route path="/attendance" element={<Attendance />} />
          </Routes>
          <div className="App">
            <ThemeProvider theme={theme}>
              <Routes>
                <Route
                  path="/dashboard"
                  element={<Sidebar content={<Dashboard />} />}
                />
                <Route
                  path="/home"
                  element={<Protected Component={Sidebar} />}
                />
                <Route path="/" element={<AccountForm />} />
                <Route path="/login" element={<LogIn />} />
                <Route
                  path="/Setting/frmCountryDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<Country />} />}
                />
                          <Route
  path="/notifications"
  element={<Sidebar content={<AdminNotifications />} />}
/>
                <Route
                  path="/AddCountry"
                  element={<Sidebar content={<AddCountry />} />}
                />
                <Route
                  path="/notification"
                  element={<StudentsSidebar content={<Notification />} />}
                />
                           <Route
  path="/student-notifications"
  element={<StudentsSidebar content={<StudentNotifications />} />}
/>
                <Route
                  path="/Purpose/:id"
                  element={<Sidebar content={<Purpose />} />}
                />

                <Route
                  path="/AddPurpose"
                  element={<Sidebar content={<AddPurpose />} />}
                />
                <Route
                  path="/EditPurpose/:id"
                  element={<Sidebar content={<EditPurpose />} />}
                />

                <Route
                  path="/Setting/FrmStatsDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<State />} />}
                />
                <Route
                  path="/editstate/:stateId"
                  element={<Sidebar content={<EditState />} />}
                />
                <Route
                  path="/EditCountry/:countryId"
                  element={<Sidebar content={<EditCountry />} />}
                />
                <Route
                  path="/addstate"
                  element={<Sidebar content={<AddState />} />}
                />

                <Route
                  path="/Setting/FrmCityDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<City />} />}
                />
                <Route
                  path="/addcity"
                  element={<Sidebar content={<AddCity />} />}
                />
                {/* <Route path="/subjectmaster/:encodedFormId" element={<Sidebar content={<SubjectMaster/>}/>} /> */}
                <Route
                  path="/editcity/:cityId"
                  element={<Sidebar content={<EditCity />} />}
                />
                <Route
                  path="/BranchOrganisation/OrganisationDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<Organization />} />}
                />
                <Route
                  path="/Master/FrmEmployeeMasterDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<Employee />} />}
                />
                <Route
                  path="/addemployee"
                  element={<Sidebar content={<AddEmployee />} />}
                />
                <Route
                  path="/editemployee/:employeeId"
                  element={<Sidebar content={<EditEmployee />} />}
                />
                <Route
                  path="/BranchOrganisation/FrmBranchDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<Branch />} />}
                />
                <Route
                  path="/addbranch"
                  element={<Sidebar content={<AddBranch />} />}
                />
                <Route
                  path="/EditBranch/:branchId"
                  element={<Sidebar content={<EditBranch />} />}
                />
                <Route
                  path="/addbranch"
                  element={<Sidebar content={<AddBranch />} />}
                />
                <Route
                  path="/ChargeDetails"
                  element={<Sidebar content={<ChargeDetails />} />}
                />
                {/* <Route path="/followupmedium/:encodedFormId" element={<Sidebar content={<FollowUpDetails/>} />}/> */}
                <Route
                  path="/Setting/FrmNationality.aspx/:encodedFormId"
                  element={<Sidebar content={<Nationality />} />}
                />
                <Route
                  path="/addnationality"
                  element={<Sidebar content={<AddNationality />} />}
                />
                <Route
                  path="/editnationality/:nationalityId"
                  element={<Sidebar content={<EditNationality />} />}
                />
                <Route
                  path="/Setting/FrmDesignationDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<Designation />} />}
                />
                <Route
                  path="/adddesignation"
                  element={<Sidebar content={<AddDesignation />} />}
                />
                <Route
                  path="/editdesignation/:desigId"
                  element={<Sidebar content={<EditDesignation />} />}
                />
                <Route
                  path="/Setting/FrmDepartmentDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<Department />} />}
                />
                <Route
                  path="/adddepartment"
                  element={<Sidebar content={<AddDepartment />} />}
                />
                <Route
                  path="/editdepartment/:deptId"
                  element={<Sidebar content={<EditDepartment />} />}
                />
                <Route
                  path="/addsource"
                  element={<Sidebar content={<AddSourceDetails />} />}
                />
                <Route
                  path="/editsource/:enquirySourceId"
                  element={<Sidebar content={<EditSourceDetails />} />}
                />
                <Route
                  path="/source"
                  element={<Sidebar content={<Source />} />}
                />
                <Route
                  path="/Setting/FrmConcessionDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<Concession />} />}
                />
                <Route
                  path="/addconcession"
                  element={<Sidebar content={<AddConcession />} />}
                />
                <Route
                  path="/editconcession/:concessionId"
                  element={<Sidebar content={<EditConcession />} />}
                />
                <Route
                  path="/addtopic"
                  element={<Sidebar content={<AddTopic />} />}
                />
                {/* <Route
                path="/edittopic"
                element={<Sidebar content={<EditTopic />} />}
              /> */}
                <Route
                  path="/editOrganization/:organisationId"
                  element={<Sidebar content={<EditOrganization />} />}
                />
                <Route
                  path="/managequiz/:encodedFormId"
                  element={<Sidebar content={<ManageQuiz />} />}
                />
                <Route
                  path="/addmanagequiz"
                  element={<Sidebar content={<AddManageQuiz />} />}
                />
                <Route
                  path="/Setting/FrmBankDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<Bank />} />}
                />
                <Route
                  path="/addbank"
                  element={<Sidebar content={<AddBank />} />}
                />
                <Route
                  path="/editbank/:bankId"
                  element={<Sidebar content={<EditBank />} />}
                />
                <Route
                  path="/Setting/FrmClassTypeDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<ClassType />} />}
                />
                <Route
                  path="/editclasstype/:classTypeId"
                  element={<Sidebar content={<EditClassType />} />}
                />
                <Route
                  path="/addclasstype"
                  element={<Sidebar content={<AddClassType />} />}
                />
                <Route
                  path="/Setting/FrmReligionDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<Religion />} />}
                />
                <Route
                  path="/addreligion"
                  element={<Sidebar content={<AddReligion />} />}
                />
                <Route
                  path="/editreligion/:religionID"
                  element={<Sidebar content={<EditReligion />} />}
                />
                <Route
                  path="/editsection/:sectionId"
                  element={<Sidebar content={<EditSection />} />}
                />
                <Route
                  path="/Setting/FrmSubjectMaster.aspx/:encodedFormId"
                  element={<Sidebar content={<SubMaster />} />}
                />
                <Route
                  path="/addsubjectmaster"
                  element={<Sidebar content={<AddSubjectMaster />} />}
                />
                <Route
                  path="/editsubmaster/:subjectID"
                  element={<Sidebar content={<UpdateSubMaster />} />}
                />
                <Route
                  path="/Setting/FrmOccupation.aspx/:encodedFormId"
                  element={<Sidebar content={<Occupation />} />}
                />
                <Route
                  path="/addoccupation"
                  element={<Sidebar content={<AddOccupation />} />}
                />
                <Route
                  path="/editoccupation/:occupationId"
                  element={<Sidebar content={<EditOccupation />} />}
                />

                <Route
                  path="/Setting/FrmChargeMasterDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<ChargeMaster />} />}
                />
                <Route
                  path="/editclasscharge/:classId"
                  element={<Sidebar content={<EditChargeMaster />} />}
                />
                <Route
                  path="/addcharge"
                  element={<Sidebar content={<AddChargeMaster />} />}
                />

                <Route
                  path="/Setting/FrmSectionDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<SectionMaster />} />}
                />
                <Route
                  path="/addsection"
                  element={<Sidebar content={<AddSection />} />}
                />

                {/* <Route path="/user" element={<Sidebar content={<User/>} />}/> */}
                <Route
                  path="/adduser"
                  element={<Sidebar content={<AddUser />} />}
                />
                {/* <Route path="/UserGroup/:encodedFormId" element={<Sidebar content={<UserGroup/>} />}/> */}
                <Route
                  path="/edituser/:userId"
                  element={<Sidebar content={<EditUser />} />}
                />
                <Route
                  path="/CPanel/UserDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<User />} />}
                />
                <Route path="/user" element={<Sidebar content={<User />} />} />
                <Route
                  path="/adduser"
                  element={<Sidebar content={<AddUser />} />}
                />
                <Route
                  path="/CPanel/UserGroupDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<UserGroup />} />}
                />
                <Route
                  path="/edituser/:userId"
                  element={<Sidebar content={<EditUser />} />}
                />

                <Route
                  path="/feeGeneration"
                  element={<Sidebar content={<FeeGenerationForm />} />}
                />
                <Route
                  path="/addOrganization"
                  element={<Sidebar content={<AddOrganisation />} />}
                />
                {/* <Route path="/interestlevel/:encodedFormId" element={<Sidebar content={<InterestLevel/>} />}/>
            <Route path="/addintrstlvl" element={<Sidebar content={<AddInrstLvl/>} />}/>
            <Route path="/editIntestlvl/:lvlId" element={<Sidebar content={<EditIntrstLvl/>} />}/> */}
                <Route
                  path="/modeofdelivery"
                  element={<Sidebar content={<DeliveryMode />} />}
                />

                <Route
                  path="/form/:encodedFormId"
                  element={<Sidebar content={<Form />} />}
                />
                <Route
                  path="/addform"
                  element={<Sidebar content={<AddForm />} />}
                />
                <Route
                  path="/editform/:formId"
                  element={<Sidebar content={<EditForm />} />}
                />
                <Route
                  path="/usergrp"
                  element={<Sidebar content={<UserGroup />} />}
                />

                <Route
                  path="/course/:encodedFormId"
                  element={<Sidebar content={<Course />} />}
                />
                <Route
                  path="/addcourse"
                  element={<Sidebar content={<AddCourse />} />}
                />
                <Route
                  path="/editcourse/:courseId"
                  element={<Sidebar content={<EditCourse />} />}
                />
                <Route
                  path="/module/:encodedFormId"
                  element={<Sidebar content={<Module />} />}
                />
                <Route
                  path="/addmodule"
                  element={<Sidebar content={<AddModule />} />}
                />
                <Route
                  path="/editmodule/:moduleId"
                  element={<Sidebar content={<EditModule />} />}
                />
                {/* <Route path="/topic/:encodedFormId" element={<Sidebar content={<Topic/>} />}/> */}
                {/* <Route
                path="/edittopic/:topicId"
                element={<Sidebar content={<EditMasterTopic />} />}
              /> */}
                <Route
                  path="/addtopic"
                  element={<Sidebar content={<AddTopic />} />}
                />
                {/* <Route
                path="/vehicletype/:encodedFormId"
                element={<Sidebar content={<Vehicle />} />}
              /> */}
                <Route
                  path="/addvehicle"
                  element={<Sidebar content={<AddVehicle />} />}
                />
                <Route
                  path="/editvehicle/:vehicleTypeId"
                  element={<Sidebar content={<EditVehicle />} />}
                />

                <Route
                  path="/Settings/FrmDueDate.aspx/:encodedFormId"
                  element={<Sidebar content={<DueDateDetails />} />}
                />
                <Route
                  path="/addfine"
                  element={<Sidebar content={<AddFine />} />}
                />
                <Route
                  path="/editfine/:fineId"
                  element={<Sidebar content={<EditFine />} />}
                />
                <Route
                  path="/Inventory/frmVendorDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<Vendor />} />}
                />
                <Route
                  path="/addvendor"
                  element={<Sidebar content={<AddVendor />} />}
                />
                <Route
                  path="/vendor/edit/:id"
                  element={<Sidebar content={<EditVendor />} />}
                />
                <Route
                  path="/addusergrp"
                  element={<Sidebar content={<AddUserGroup />} />}
                />
                <Route
                  path="/editusergrp/:userGroupId"
                  element={<Sidebar content={<EditUserGroup />} />}
                />

                <Route
                  path="/Quiz/FrmQuestionDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<Question />} />}
                />
                <Route
                  path="/addquestion"
                  element={<Sidebar content={<QuestionMaster />} />}
                />
                <Route
                  path="/editquestion/:questionId"
                  element={<Sidebar content={<EditQuestion />} />}
                />

                <Route
                  path="/adddeliverymode"
                  element={<Sidebar content={<AddDelivery />} />}
                />
                <Route
                  path="/editdeliverymode/:modeId"
                  element={<Sidebar content={<EditDelivery />} />}
                />
                <Route
                  path="/status/:encodedFormId"
                  element={<Sidebar content={<Status />} />}
                />
                <Route
                  path="/addstatus"
                  element={<Sidebar content={<AddStatus />} />}
                />
                <Route
                  path="/editstatus/:statusId"
                  element={<Sidebar content={<EditStatus />} />}
                />
                <Route
                  path="/Mapping/FrmClassSubjectMapping.aspx/:encodedFormId"
                  element={<Sidebar content={<ClassMapping />} />}
                />
                <Route
                  path="/Mapping/FrmTeacherMapping.aspx/:encodedFormId"
                  element={<Sidebar content={<ClassTeacherMapping />} />}
                />
                <Route
                  path="/addmastertopic"
                  element={<Sidebar content={<AddMasterTopic />} />}
                />
                <Route
                  path="/OfflineModule/OfflineTopicMasterDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<TopicPage />} />}
                />
                <Route
                  path="/edittopicmaster/:topicId"
                  element={<Sidebar content={<EditTopicMaster />} />}
                />
                <Route
                  path="/addregistration"
                  element={<Sidebar content={<AddRegistration />} />}
                />
                <Route
                  path="/scanregistration"
                  element={<Sidebar content={<ScanRegistration />} />}
                />
                <Route
                  path="/addlession"
                  element={<Sidebar content={<AddLession />} />}
                />
                <Route
                  path="/OfflineModule/OfflineSubjectMasterDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<LessonPage />} />}
                />
                <Route
                  path="/updatelesson/:LessionId"
                  element={<Sidebar content={<UpdateLession />} />}
                />
                <Route
                  path="/addadmission"
                  element={<Sidebar content={<AddAdmission />} />}
                />
                <Route
                  path="/Admission/FrmAdmissionDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<Admission />} />}
                />
                <Route
                  path="/updateadmission/:studentId"
                  element={<Sidebar content={<UpdateAdmission />} />}
                />
                <Route
                  path="/bulk-id-card"
                  element={<Sidebar content={<BulkIdCard />} />}
                />
                <Route
                  path="/subcategory/:encodedFormId"
                  element={<Sidebar content={<SubCategory />} />}
                />
                <Route
                  path="/editsubcategory/:subcategoryId"
                  element={<Sidebar content={<SubCategoryUpdate />} />}
                />
                <Route
                  path="/addenquiry"
                  element={<Sidebar content={<Enquiry />} />}
                />
                <Route
                  path="/editenquiry/:enquiryId"
                  element={<Sidebar content={<UpdateEnquiry />} />}
                />
                <Route
                  path="/Enquiry/FrmEnquiryDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<EnquiryDetails />} />}
                />
                <Route
                  path="/Enquiry/EnquiryFollowUp.aspx/:encodedFormId"
                  element={<Sidebar content={<EnquiryFollow />} />}
                />
                <Route
                  path="/addregistration"
                  element={<Sidebar content={<AddRegistration />} />}
                />
                <Route
                  path="/Admission/FrmRegistrationDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<Registration />} />}
                />
                <Route
                  path="/updateregistration/:registrationId"
                  element={<Sidebar content={<UpdateRegistration />} />}
                />
                <Route
                  path="/Setting/FrmClassDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<Class />} />}
                />
                <Route
                  path="/addclass"
                  element={<Sidebar content={<AddClass />} />}
                />
                <Route
                  path="/editclass/:classId"
                  element={<Sidebar content={<EditClass />} />}
                />
                <Route
                  path="/Quiz/FrmQuizzDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<ManageQuiz />} />}
                />
                <Route
                  path="/addquiz"
                  element={<Sidebar content={<SettingQuiz />} />}
                />
                <Route
                  path="/editquiz/:quizId"
                  element={<Sidebar content={<EditQuiz />} />}
                />
                <Route
                  path="/Mapping/AssignmentUploade.aspx/:encodedFormId"
                  element={<Sidebar content={<AssignmentCreate />} />}
                />
                <Route
                  path="/assignmentcreateform"
                  element={<Sidebar content={<AssignmentCreateForm />} />}
                />
                <Route
                  path="/Mapping/FrmAssignmentDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<Assignment />} />}
                />
                <Route
                  path="/updateassignment/:id"
                  element={<Sidebar content={<AssignementUpdate />} />}
                />
                <Route
                  path="/Fees/FrmFeeGeneration.aspx/:encodedFormId"
                  element={<Sidebar content={<FeeGeneration />} />}
                />
                <Route
                  path="/Fees/FrmDeposit.aspx/:encodedFormId"
                  element={<Sidebar content={<FeeDeposit />} />}
                />
                <Route
                  path="/annual-payment"
                  element={<Sidebar content={<AnnualPayment />} />}
                />
                <Route
                  path="/Dues List/:encodedFormId"
                  element={<Sidebar content={<FeeDuesDetails />} />}
                />
                <Route
                  path="/Examination/FrmExaminationCriteria.aspx/:encodedFormId"
                  element={<Sidebar content={<AddExamCriteria />} />}
                />
                <Route
                  path="/updateexamcriteria/:examCriteriaId"
                  element={<Sidebar content={<UpdateExamCriteria />} />}
                />
                <Route
                  path="/Examination/FrmExamSubCategory.aspx/:encodedFormId"
                  element={<Sidebar content={<AddExamSubCategory />} />}
                />
                <Route
                  path="/updateexamsubcategory/:subCategoryId"
                  element={<Sidebar content={<UpdateExamSubCategory />} />}
                />
                <Route
                  path="/Examination/FrmInternalExam.aspx/:encodedFormId"
                  element={<Sidebar content={<AddExam />} />}
                />
                <Route
                  path="/result/:encodedFormId"
                  element={<Sidebar content={<Result />} />}
                />
                <Route
                  path="/Report/Fee/FrmFeereport.aspx/:encodedFormId"
                  element={<Sidebar content={<Payment />} />}
                />
                <Route
                  path="/Report/Student/FrmStudentReport.aspx/:encodedFormId"
                  element={<Sidebar content={<AdmissionReport />} />}
                />
                <Route
                  path="/Report/Attanance/FrmAttananceReport.aspx/:encodedFormId"
                  element={<Sidebar content={<AttendanceReport />} />}
                />
                <Route
                  path="/Admission/FrmClassTranfer.aspx/:encodedFormId"
                  element={<Sidebar content={<ClassPromotion />} />}
                />
                <Route
                  path="/receiptprint"
                  element={<Sidebar content={<ReceiptPrint />} />}
                />
                <Route
                  path="/Attendance/FrmStudentAttendanceDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<Attendance />} />}
                />
                <Route
                  path="/brand/:encodedFormId"
                  element={<Sidebar content={<Brand />} />}
                />
                <Route
                  path="/Inventory/FrmPODetails.aspx/:encodedFormId"
                  element={<Sidebar content={<StockInward />} />}
                />
                <Route
                  path="/Inventory/FrmPoInvoiceDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<StockReturn />} />}
                />
                <Route
                  path="/stockinward/add"
                  element={<Sidebar content={<AddStockInward />} />}
                />
                <Route
                  path="/stockreturn/add"
                  element={<Sidebar content={<AddStockReturn />} />}
                />
                <Route
                  path="/addattendance"
                  element={<Sidebar content={<AddAttendance />} />}
                />
                <Route
                  path="/attendance"
                  element={<Sidebar content={<Attendance />} />}
                />
                <Route
                  path="/empattendance-form"
                  element={<Sidebar content={<AttendanceForm />} />}
                />
                <Route
                  path="/attendance/EmployeeAttendanceDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<EmployeeAttendance />} />}
                />

                <Route
                  path="/changepassword"
                  element={<Sidebar content={<ChangePassword />} />}
                />
                <Route
                  path="/messagetemplate/:encodedFormId"
                  element={<Sidebar content={<TemplateTable />} />}
                />
                <Route
                  path="/create-template/"
                  element={<Sidebar content={<TemplateForm />} />}
                />
                <Route
                  path="/edit-template/"
                  element={<Sidebar content={<EditTemplate />} />}
                />
                <Route
                  path="/whatsappApi/:encodedFormId"
                  element={<Sidebar content={<ApiTable />} />}
                />
                <Route
                  path="/add-api"
                  element={<Sidebar content={<AddApiForm />} />}
                />
                <Route
                  path="/viewapiform/:configId"
                  element={<Sidebar content={<ApiForm />} />}
                />
                <Route
                  path="/Transportation/FrmVechileMasterDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<ManageVehicle />} />}
                />
                <Route
                  path="/manage-vehicle/add"
                  element={<Sidebar content={<AddManageVehicle />} />}
                />
                <Route
                  path="/manage-vehicle/edit/:Id"
                  element={<Sidebar content={<EditManageVehicle />} />}
                />
                <Route
                  path="/Transportation/FrmRouteMaster.aspx/:encodedFormId"
                  element={<Sidebar content={<ManageRoute />} />}
                />
                <Route
                  path="/manage-route/add"
                  element={<Sidebar content={<AddRoutes />} />}
                />
                <Route
                  path="/manage-route/edit/:routeID"
                  element={<Sidebar content={<EditRoutes />} />}
                />
                <Route
                  path="/Setting/FrmDriverDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<Driver />} />}
                />
                <Route
                  path="/Transportation/FrmRoutMapping.aspx/:encodedFormId"
                  element={<Sidebar content={<RouteVehicleMapping />} />}
                />
                <Route
                  path="/studentdashboard"
                  element={<StudentsSidebar content={<StdDashboard />} />}
                />
                <Route
                  path="/student-topic-progress"
                  element={<StudentsSidebar content={<StudentTopicProgress />} />}
                />
                <Route
                  path="/homework"
                  element={<StudentsSidebar content={<StudentHomework />} />}
                />

                <Route
                  path="/assignmentlist"
                  element={<StudentsSidebar content={<AssignmentList />} />}
                />
                <Route
                  path="/studentassignmentDetails"
                  element={<StudentsSidebar content={<AssignmentDetails />} />}
                />
                <Route
                  path="/comingsoon" // Define the path for the ComingSoon page
                  element={<StudentsSidebar content={<CommingSoon />} />} // Nest it inside StudentsSidebar
                />
                <Route path="/abc" element={<GeneratePDFButton />} />
                <Route
                  path="/leavingcertif"
                  element={<Sidebar content={<LeavingCertificate />} />}
                />
                <Route
                  path="/StudentTC/:encodedFormId"
                  element={<Sidebar content={<SLCManagement />} />}
                />
                <Route
                  path="/addtimetable"
                  element={<Sidebar content={<CreateTimeTab />} />}
                />
                <Route
                  path="/Timetable/:encodedFormId"
                  element={<Sidebar content={<GetTimeTab />} />}
                />
                <Route
                  path="/Caste/:encodedFormId"
                  element={<Sidebar content={<Caste />} />}
                />
                <Route
                  path="/edit-caste/:casteId"
                  element={<Sidebar content={<EditCaste />} />}
                />
                <Route
                  path="/add-caste"
                  element={<Sidebar content={<AddCaste />} />}
                />
                <Route
                  path="/timeperiod/:encodedFormId"
                  element={<Sidebar content={<PeriodTable />} />}
                />
                <Route
                  path="/addperiodseq"
                  element={<Sidebar content={<AddPeriod />} />}
                />
                <Route
                  path="/edit-period/:encodedFormId"
                  element={<Sidebar content={<EditPeriod />} />}
                />
                <Route
                  path="/subjects"
                  element={<StudentsSidebar content={<SubjectsPage />} />}
                />
                <Route
                  path="/lessons/:classId/:subjectId"
                  element={<StudentsSidebar content={<LssnPg />} />}
                />
                <Route
                  path="/topics/:classId/:subjectId/:lessonId"
                  element={<StudentsSidebar content={<TopicsPage />} />}
                />
                <Route
                  path="/time-table"
                  element={<StudentsSidebar content={<TymTbl />} />}
                />
                <Route
                  path="/resultgeneration/:encodedFormId"
                  element={<Sidebar content={<ResultGeneration />} />}
                />
                <Route
                  path="/StudentProfile/FrmStudentResult.aspx/:encodedFormId"
                  element={<Sidebar content={<GeneratedResult />} />}
                />
                <Route
                  path="/studentuser"
                  element={<Sidebar content={<StudentUser />} />}
                />
                <Route
                  path="/Admission/FrmStudentUser.aspx/:encodedFormId"
                  element={<Sidebar content={<CreateNewUser />} />}
                />
                <Route
                  path="/changepassword"
                  element={<Sidebar content={<ChangePassword />} />}
                />
                <Route
                  path="/template/:encodedFormId"
                  element={<Sidebar content={<TemplateTable />} />}
                />
                <Route
                  path="/create-template/"
                  element={<Sidebar content={<TemplateForm />} />}
                />
                <Route
                  path="/edit-template/"
                  element={<Sidebar content={<EditTemplate />} />}
                />
                <Route
                  path="/whatsappapi/:encodedFormId"
                  element={<Sidebar content={<ApiTable />} />}
                />
                <Route
                  path="/add-api"
                  element={<Sidebar content={<AddApiForm />} />}
                />
                <Route
                  path="/viewapiform/:configId"
                  element={<Sidebar content={<ApiForm />} />}
                />

                <Route
                  path="/studentdashboard"
                  element={<StudentsSidebar content={<StdDashboard />} />}
                />
                <Route
                  path="/assignmentlist"
                  element={<StudentsSidebar content={<AssignmentList />} />}
                />
                <Route
                  path="/studentassignmentDetails/:subjectId"
                  element={<StudentsSidebar content={<AssignmentDetails />} />}
                />
                <Route path="/xyz" element={<GeneratePDFButton />} />
                <Route
                  path="/leavingcertif"
                  element={<Sidebar content={<LeavingCertificate />} />}
                />
                <Route
                  path="/studenttc/:encodedFormId"
                  element={<Sidebar content={<SLCManagement />} />}
                />
                <Route
                  path="/addtimetable"
                  element={<Sidebar content={<CreateTimeTab />} />}
                />
                <Route
                  path="/timetable/:encodedFormId"
                  element={<Sidebar content={<GetTimeTab />} />}
                />
                <Route
                  path="/caste/:encodedFormId"
                  element={<Sidebar content={<Caste />} />}
                />
                <Route
                  path="/edit-caste/:casteId"
                  element={<Sidebar content={<EditCaste />} />}
                />
                <Route
                  path="/add-caste"
                  element={<Sidebar content={<AddCaste />} />}
                />
                <Route
                  path="/timeperiod/:encodedFormId"
                  element={<Sidebar content={<PeriodTable />} />}
                />
                <Route
                  path="/addperiodseq"
                  element={<Sidebar content={<AddPeriod />} />}
                />
                <Route
                  path="/subjects"
                  element={<StudentsSidebar content={<SubjectsPage />} />}
                />
                <Route
                  path="/lessons/:classId/:subjectId"
                  element={<StudentsSidebar content={<LssnPg />} />}
                />
                <Route
                  path="/topics/:classId/:subjectId/:lessonId"
                  element={<StudentsSidebar content={<TopicsPage />} />}
                />
                <Route
                  path="/time-table"
                  element={<StudentsSidebar content={<TymTbl />} />}
                />
                <Route
                  path="/resultgeneration/:encodedFormId"
                  element={<Sidebar content={<ResultGeneration />} />}
                />
                <Route
                  path="/getresult/:encodedFormId"
                  element={<Sidebar content={<GeneratedResult />} />}
                />
                <Route
                  path="/studentuser/:encodedFormId"
                  element={<Sidebar content={<StudentUser />} />}
                />
                <Route
                  path="/create-new-user"
                  element={<Sidebar content={<CreateNewUser />} />}
                />
                <Route
                  path="/stream/:encodedFormId"
                  element={<Sidebar content={<StreamPage />} />}
                />
                <Route
                  path="/AddStream"
                  element={<Sidebar content={<AddStream />} />}
                />
                <Route
                  path="/EditStream"
                  element={<Sidebar content={<EditStream />} />}
                />
                <Route
                  path="/admitpage/:encodedFormId"
                  element={<Sidebar content={<AdmitPage />} />}
                />
                <Route
                  path="/admitCard/:encodedFormId"
                  element={<Sidebar content={<AdmitCard />} />}
                />
                <Route
                  path="/Inventory/FrmSubCategory.aspx/:encodedFormId"
                  element={<Sidebar content={<InventoryLocation />} />}
                />

                <Route
                  path="/location/add"
                  element={<Sidebar content={<AddLocation />} />}
                />

                <Route
                  path="/location/edit/:locationId"
                  element={<Sidebar content={<EditLocation />} />}
                />

                <Route
                  path="/Inventory/FrmItemMaster.aspx/:encodedFormId"
                  element={<Sidebar content={<ManageInventoryItems />} />}
                />
                <Route
                  path="/inventory/add"
                  element={<Sidebar content={<AddInventoryItem />} />}
                />
                <Route
                  path="/Inventory/FrmMainCategory.aspx/:encodedFormId"
                  element={<Sidebar content={<MainCategory />} />}
                />
                <Route
                  path="/itemcategorymaster/add"
                  element={<Sidebar content={<AddMainCategory />} />}
                />
                <Route
                  path="/inventory/edit/:itemId"
                  element={<Sidebar content={<EditInventoryItem />} />}
                />
                <Route
                  path="/edit-main-category/:mainCategoryId"
                  element={<Sidebar content={<EditMainCategory />} />}
                />
                <Route
                  path="/edit-inward/:stockInwardID"
                  element={<EditStockInward />}
                />
                <Route
                  path="/Inventory/FrmStockOutWardDetails.aspx/:encodedFormId"
                  element={<Sidebar content={<StockIssuance />} />}
                />

                {/* nabil */}
                <Route
                  path="/InventoryReport/:encodedFormId"
                  element={<Sidebar content={<InventoryReport />} />}
                />
                <Route path="/student-enquiry/:token" element={<StudentEnquiry />} />
                <Route path="/student-registration/:token" element={<StudentRegistration />} />
                <Route
                  path="/Vehicle Master/FrmRouteCharge/:encodedFormId"
                  element={<Sidebar content={<ManageVehicleType />} />}
                />
                <Route
                  path="/add-vehicle-type"
                  element={<Sidebar content={<AddVehicleType />} />}
                />
                <Route
                  path="/manage-vehicle-type/edit/:vehicleTypeId"
                  element={<Sidebar content={<EditVehicleType />} />}
                />

                {/* Form Modules */}
                <Route
                  path="/CPanel/ModuleDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<FormModules />} />}
                />
                <Route
                  path="/add-form-module"
                  element={<Sidebar content={<AddFormModules />} />}
                />
                <Route
                  path="/edit-form-module/:moduleId"
                  element={<Sidebar content={<EditFormModules />} />}
                />

                {/* Form Register */}
                <Route
                  path="/CPanel/FormNameDetail.aspx/:encodedFormId"
                  element={<Sidebar content={<FormRegister />} />}
                />
                <Route
                  path="/add-form-register"
                  element={<Sidebar content={<AddFormRegister />} />}
                />
                <Route
                  path="/edit-form-register/:formId"
                  element={<Sidebar content={<EditFormRegister />} />}
                />

                {/* Teacher Tracker starts*/}
                <Route
                  path="/TeacherTracker/AllTopics/:formId"
                  element={<Sidebar content={<AllTopic />} />}
                />
                <Route
                  path="/add-all-topic"
                  element={<Sidebar content={<AddAllTopic />} />}
                />
                <Route
                  path="/edit-topic/:topicId"
                  element={<Sidebar content={<EditAllTopic />} />}
                />
                <Route
                  path="/TeacherTracker/TopicProgress/:formId"
                  element={<Sidebar content={<TopicProgress />} />}
                />
                <Route
                  path="/TeacherTracker/Homework/:formId"
                  element={<Sidebar content={<Homework />} />}
                />
                <Route
                  path="/add-homework"
                  element={<Sidebar content={<AddHomework />} />}
                />
                <Route
                  path="/edit-homework/:id"
                  element={<Sidebar content={<EditHomework />} />}
                />

                {/* Teacher Tracker ends*/}

                {/* Teacher Load Tracker starts*/}
                <Route
                  path="/teacher-load-tracker/overview/:formId"
                  element={<Sidebar content={<Overview />} />}
                />
                <Route
                  path="/teacher-load-tracker/report/:formId"
                  element={<Sidebar content={<TeacherLoadReport />} />}
                />
                <Route
                  path="/teacher-load-tracker/config/:formId"
                  element={<Sidebar content={<TeacherLoadConfig />} />}
                />
                <Route
                  path="/teacher-load-tracker/time-table/:formId"
                  element={<Sidebar content={<TeacherLoadTimeTable />} />}
                />
                <Route
                  path="/teacher-load-tracker/subject-master/:formId"
                  element={<Sidebar content={<SubjectTarget />} />}
                />
                <Route
                  path="/teacher-load-tracker/teacher-load-heat-map/:formId"
                  element={<Sidebar content={<TeacherLoadHeatmap />} />}
                />
                <Route
                  path="/teacher-load-tracker/proxy-management/:formId"
                  element={<Sidebar content={<ProxyManagement />} />}
                />

                {/* Teacher Load Tracker starts*/}
               
       
                <Route
                  path="/Announcement/Create-Announcement/:formId"
                  element={<Sidebar content={<CreateAnnouncement />} />}
                />

                <Route
                  path="/Announcement/View-Announcement/:formId"
                  element={<Sidebar content={<ViewAnnouncement />} />}
                />

                <Route
                  path="/edit-announcement/:id"
                  element={<Sidebar content={<EditAnnouncement />} />}
                />

                {/* Admin Announcemnt ends */}

                {/* Manage User */}
                <Route
                  path="/CPanel/UserControlPanel/UserGroupRole.aspx/:encodedFormId"
                  element={<Sidebar content={<ManageUser />} />}
                />
                <Route
                  path="/teachersDashboard"
                  element={<DashboardMain content={<DashContent />} />}
                />
                           <Route
  path="/teacher-notifications"
  element={<DashboardMain content={<TeacherNotifications />} />}
/>
                <Route path="/Timetable" element={<DashboardMain content={<TimetablePage />} />} />
                <Route path="/admitcard" element={<DashboardMain content={<AdmitCardPage />} />} />
                <Route path="/admitpage" element={<DashboardMain content={<AdmitPagee />} />} />
                <Route path="/chat-app" element={<DashboardMain content={<ChatsApp />} />} />
                <Route path="/Attendance/FrmStudentAttendanceDetails.aspx" element={<DashboardMain content={<ViewAttendance />} />} />
                <Route path="/attendance-form" element={<DashboardMain content={<AttendanceeForm />} />} />
                <Route path="/Admission/EnquiryFormDetails.aspx" element={<DashboardMain content={<Lessons />} />} />
                <Route path="/addlesson" element={<DashboardMain content={<LessonAdd />} />} />
                <Route path="/editlesson/:lessonId" element={<DashboardMain content={<LessonEdit />} />} />
                <Route path="/Examination/FrmInternalExam.aspx/Topic" element={<DashboardMain content={<Topics />} />} />
                <Route path="/addtopic" element={<DashboardMain content={<TopicAdd />} />} />
                <Route path="/edittopic/:topicId" element={<DashboardMain content={<TopicEdit />} />} />
                <Route path="/Mapping/AssignmentUploade.aspx" element={<DashboardMain content={<CreateAssignment />} />} />
                <Route path="/Mapping/FrmAssignmentDetails.aspx" element={<DashboardMain content={<ViewAssignment />} />} />
                <Route path="/Examination/FrmInternalExam.aspx" element={<DashboardMain content={<Exam />} />} />
                <Route path="/assignmentedit/:assignmentId" element={<DashboardMain content={<EditAssignment />} />} />
                <Route path="/profile-details" element={<DashboardMain content={<ProfileDetails />} />} />
                <Route path="/subject-detail" element={<DashboardMain content={<SubjectDetail />} />} />
                <Route path="/TeacherTracker/TopicProgress" element={<DashboardMain content={<TopicProgresss
                />} />} />
                <Route path="/TeacherTracker/AllTopics" element={<DashboardMain content={<TeacherAllTopics
                />} />} />
                 <Route path="/teacher-load-tracker/proxy-management" element={<DashboardMain content={<MyDuties
                />} />} />

                <Route path="/teacher-load-tracker/time-table" element={<DashboardMain content={<TeacherTimeTablePage/>}/>}/>
                <Route path="/TeacherTracker/AllTopics/add-topic" element={<DashboardMain content={<AddTeacherAllTopic
                />} />} />
                <Route path="/TeacherTracker/AllTopics/edit-topic/:topicId" element={<DashboardMain content={<EditTeacherAllTopic
                />} />} />
                <Route path="/Announcement/View-Announcement" element={<DashboardMain content={<Announcement
                />} />} />
                <Route path="/TeacherTracker/MyAttendance" element={<DashboardMain content={<TeacherAttendance />} />} />
                <Route path="/TeacherTracker/Homework" element={<DashboardMain content={<TeacherHomework />} />} />
                <Route path="/add-teacher-homework" element={<DashboardMain content={<AddTeacherHomework />} />} />
                <Route path="/edit-teacher-homework/:id" element={<DashboardMain content={<EditTeacherHomework />} />} />

                {/* nabil */}
              </Routes>
            </ThemeProvider>
          </div>
        </IdleTimeout>
      </BrowserRouter>
      {/* <AddUserForm/> */}
      {/* <EditUserForm/> */}
    </>
  );
}
const EditCountryWrapper = () => {
  const location = useLocation();
  const { countryId, countryName } = location.state || {};

  return <EditCountry countryId={countryId} countryName={countryName} />;
};
export default App;
